import React, { useEffect, useState } from "react";
import DashboardHeader from "../../components/Other/DashboardHeader";
import PageHeaderTitle from "../../components/pages/PageHeaderTitle";
import FollowersSection from "../../components/Other/FollowersSection";
import { getGameFromSlug } from "../../api/user";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

const LeagueFollowerList = () => {
  const [sidebarToggle] = useOutletContext();
  const { t } = useTranslation();
  const { slug, user_id } = useParams();
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const loggedUserId = localStorage.getItem("user_id");

  const isSelfProfile = loggedUserId === user_id;

  useEffect(() => {
    const checkGameDates = (start_date, end_date) => {
      const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
      const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
      const today = new Date(); // Get today's date
      today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

      if (today >= startDate && today <= endDate) {
        return true;
      } else {
        return false;
      }
    };

    const fetchGameId = async (slug) => {
      try {
        const response = await getGameFromSlug({ slug });
        const gameData = response?.data?.data;

        if (gameData) {
          if (checkGameDates(gameData.start_date, gameData.end_date)) {
            setGame(gameData);
            setLoading(true);
          } else {
            setGame(gameData);
            setLoading(true);
            // toast.error("League is not active");
            // navigate("/contest/my-games");
            // navigate("/contest/my-games", { state: { viewMode: "member" } });
          }
        } else {
          //  toast.error("League not found");
          // navigate("/contest/my-games");
          //  navigate("/contest/my-games", { state: { viewMode: "member" } });
        }
      } catch (error) {
        console.error("Error fetching game ID:", error);
      }
    };

    fetchGameId(slug);
  }, [slug]);

  return (
    <>
      {loading && (
        <>
          <DashboardHeader toggle={sidebarToggle} />
          {/* Client Rev 2, global League Play rule 1: "Remove any screen title
                from under the QUSHi header logo." The league identity lives in
                LeagueShell now, so this second title was a duplicate.

                KEPT as a title-less PageHeaderTitle rather than deleted: this
                component is not only a title, it is also the spacer that clears
                the FIXED DashboardHeader (a desktop `h-16` block, and an `mt-16`
                wrapper on mobile). Deleting it outright slid the whole screen up
                under the header — the composer's avatar and "Posting to…" line
                were cut off, and Portfolio's tabs disappeared behind the logo.
                `showDesktopTitle={false}` drops the only visible title (the
                mobile one was already gated off) and keeps both offsets. */}
                <PageHeaderTitle showDesktopTitle={false} />
          <FollowersSection gameId={game.id} slug={slug}/>
        </>
      )}
    </>
  );
};

export default LeagueFollowerList;
